import { api } from "../Api/api";

interface PhoneNumber {
	id: string;
	number: string;
	type: string;
}

export interface PhoneNumbersResponse {
	success: boolean;
	phones: PhoneNumber[] | null;
}

export interface ValidateDocumentRequest {
	document: string;
}

export interface ValidateDocumentResponse {
	status: "active" | "inactive";
	nextStep: "SELECT_PHONE" | "CONFIRM_AUTHENTICATION";
}

export const validateDocument = async (request: ValidateDocumentRequest): Promise<ValidateDocumentResponse> => {
	try {
		const response = await api.post<ValidateDocumentResponse>('/auth/validate-document', request);
		console.log("response", response.data);
		return response.data;
	} catch (error) {
		console.error("Erro ao validar documento:", error);
		// Re-lançar o erro original para preservar o status HTTP
		throw error;
	}
};

export const getPhoneNumbers = async (document?: string): Promise<PhoneNumbersResponse> => {
	try {
		// Simular delay da API
		await new Promise(resolve => setTimeout(resolve, 1000));

		// Validação: se o documento for 11111111111, retorna null
		if (document === "11111111111") {
			return {
				success: true,
				phones: null
			};
		}

		if (document === "11111111111111") {
			return {
				success: true,
				phones: null
			};
		}

		// Simular resposta da API com 2 números de telefone
		const mockPhones: PhoneNumber[] = [
			{
				id: "1",
				number: "(21) 98054-37777",
				type: "Celular"
			},
			{
				id: "2", 
				number: "(11) 96548-41574",
				type: "Fixo"
			}
		];

		return {
			success: true,
			phones: mockPhones
		};
	} catch (error) {
		console.error("Erro ao buscar números de telefone:", error);
		throw new Error("Erro ao buscar números de telefone");
	}
};
